import { cn } from "@omni/utils/styles";

import { RouterModal } from "@/components/General/Modal/routerModal";
import { Label } from "@/components/Product/energyLabel/components/label";
import { ModalType } from "@/redux/modules/value/modal/modal.types";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";

type Props = {
    className?: string;
};

export const EnergyLabelModal = ({ className }: Props) => {
    const { t } = useGranite();

    return (
        <RouterModal
            className={cn(className)}
            modalType={ModalType.EnergyLabel}
            withFooter={false}
            size={"lg"}
            title={t("modal.energy-label.title")}
        >
            <Label />
        </RouterModal>
    );
};
